import { FormattedMessage, useIntl } from '@alltrails/shared/react-intl';

const createReactClass = require('create-react-class');

const BasePhotoCaption = createReactClass({
  getInitialState() {
    return {
      title: this.props.title,
      originalTitle: this.props.title,
      editing: false,
      saving: false
    };
  },
  componentDidMount() {
    // expand caption-title on click
    $('#cboxTitle').off('click');
    $('#cboxTitle').click(function () {
      const $captionTitle = $('.caption-title');
      if ($captionTitle.css('white-space') === 'nowrap') {
        $captionTitle.css('white-space', 'normal').css('word-break', 'break-word');
      } else {
        $captionTitle.css('white-space', 'nowrap').css('word-break', 'normal');
      }
    });
  },
  componentDidUpdate() {
    // prevent keyDown events from propagating to colorbox for arrow keys
    $('.caption-edit').keydown(function (e) {
      if (e.keyCode >= 37 && e.keyCode <= 40) {
        e.stopPropagation();
      }
    });
  },
  toggleEdit() {
    if (this.state.editing) {
      this.setState({ editing: false, title: this.state.originalTitle });
    } else {
      this.setState({ editing: true, originalTitle: this.state.title });
    }
  },
  save() {
    this.setState({ saving: true });
    let newTitle = this.state.title;
    $.ajax({
      url: `/api/alltrails/photos/${this.props.photoId}?key=3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i`,
      type: 'PUT',
      data: { title: newTitle },
      success: function (result) {
        if (result && result.photos && result.photos.length > 0) {
          newTitle = result.photos[0].title;
        }
        this.setState({ editing: false, saving: false, title: newTitle });
        const $captionTitle = $('.caption-title');
        if ($captionTitle.css('white-space') !== 'nowrap') {
          $captionTitle.css('white-space', 'nowrap').css('word-break', 'normal');
        }
      }.bind(this),
      error: function () {
        this.setState({ saving: false });
        alert(this.props.intl.formatMessage({ defaultMessage: 'Error occurred' }));
      }.bind(this)
    });
  },
  handleChange(e) {
    this.setState({ title: e.target.value });
  },
  renderTitle() {
    return this.props.titleUrl ? (
      <a href={this.props.titleUrl} target="_blank">
        {this.state.title}
      </a>
    ) : (
      this.state.title
    );
  },
  renderTitleInput() {
    return <input className="caption-edit" type="text" value={this.state.title} onChange={this.handleChange} />;
  },
  renderEditButton() {
    if (this.state.saving) {
      return (
        <span>
          {' '}
          - <FormattedMessage defaultMessage="Saving..." />
        </span>
      );
    }
    return (
      <span>
        <span> - </span>
        {this.state.editing ? (
          <span>
            <a className="link caption-edit-btn" onClick={this.save}>
              <FormattedMessage defaultMessage="Save" />
            </a>{' '}
            |{' '}
          </span>
        ) : undefined}
        <a className="link caption-edit-btn" onClick={this.toggleEdit}>
          {this.state.editing ? <FormattedMessage defaultMessage="Cancel" /> : <FormattedMessage defaultMessage="Edit" />}
        </a>
      </span>
    );
  },
  render() {
    if (!this.props.photoId) return undefined;
    return (
      <div className={`photo-caption xlate-none`} title={this.state.title}>
        <span className="caption-title">{this.state.editing ? this.renderTitleInput() : this.renderTitle()}</span>
        {this.props.canEdit ? this.renderEditButton() : undefined}
      </div>
    );
  }
});

BasePhotoCaption.defaultProps = {
  title: '',
  titleUrl: null,
  canEdit: false
};

const PhotoCaption = props => {
  const intl = useIntl();
  return <BasePhotoCaption {...props} intl={intl} />;
};

export { PhotoCaption };
